import type {VariantObject} from '../interfaces'

export const toVariantObject = <
  T extends {
    id: string | null
    min_qty: string
    name_plural: string
    name_singular: string
    qty_per_unit: string
    price: {
      gross: string
      net: string
    }
  }
>(
  value: T,
): VariantObject | null => ({
  id: value.id ?? null,
  min_qty: parseFloat(value.min_qty ?? '0'),
  qty_per_unit: parseFloat(value.qty_per_unit ?? '0'),
  prices: {
    gross: parseFloat(value.price?.gross ?? '0'),
    net: parseFloat(value.price?.net ?? '0'),
  },
  name_plural: value.name_plural ?? null,
  name_singular: value.name_singular ?? null,
})
